import Vue from 'vue'
import { EventBus } from '@/router/bus'
import i18n from '@/i18n'
import Moment from 'moment'

Vue.mixin({
  data () {
    return {
      banks: [
        { bankId: '105', bankName: 'Agroindustrijska komercijalna banka AIK banka, AD, Beograd' },
        { bankId: '115', bankName: 'Mobi banka, AD, Beograd' },
        { bankId: '145', bankName: 'Adriatic Bank AD, Beograd' },
        { bankId: '150', bankName: 'Eurobank direktna, AD, Beograd' },
        { bankId: '155', bankName: 'Halkbank, AD, Beograd' },
        { bankId: '160', bankName: 'Banca Intesa, AD, Beograd' },
        { bankId: '165', bankName: 'Addiko Bank, AD, Beograd' },
        { bankId: '170', bankName: 'Unicredit Bank Srbija, AD, Beograd' },
        { bankId: '190', bankName: 'Alta Banka, AD, Beograd' },
        { bankId: '200', bankName: 'Banka Poštanska štedionica, AD, Beograd' },
        { bankId: '205', bankName: 'NLB Komercijalna banka, AD, Beograd' },
        { bankId: '220', bankName: 'ProCredit Bank, AD, Beograd' },
        { bankId: '265', bankName: 'Raiffeisen banka, AD, Beograd' },
        { bankId: '295', bankName: 'Srpska banka, AD, Beograd' },
        { bankId: '325', bankName: 'OTP banka Srbija, AD, Novi Sad' },
        { bankId: '340', bankName: 'Erste Bank, AD, Novi Sad' },
        { bankId: '370', bankName: '3 banka, AD, Novi Sad' },
        { bankId: '375', bankName: 'API Bank, AD, Beograd' },
        { bankId: '380', bankName: 'Mirabank, AD, Beograd' }
      ],
      generatedIdentificationNumbers: {
        885: ' - Затвореник/Доставио УИКС',
        886: ' - Oзначен на основу Закона о спречавању тероризма',
        996: ' - Пензионер без личне карте',
        997: ' - Социјална категорија без личне карте'
      },
      UserStatus: {
        PENDING: 1,
        ACTIVE: 2,
        WAITING_ACCOUNT: 3,
        PROCESSED: 4,
        COMPLETED: 5,
        REJECTED: 6,
        ERROR: 7,
        BLOCKED: 8,
        TEMP_BLOCKED: 9
      },
      UserType: {
        EMPLOYED: 1,
        UNEMPLOYED: 2,
        RETIRED: 3,
        RETIREDCASHPAYMENTS: 4,
        BENEFICIARY: 5,
        OTHER: 6
      }
    }
  },
  methods: {
    isProductionEnvironment () {
      return process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase() || process.env.NODE_ENV === 'pmiproduction'
    },
    formatShortDate (date) {
      const formattedDate = new Date(date)
      var options = { year: 'numeric', month: 'numeric', day: 'numeric' }
      return formattedDate.toLocaleDateString(Vue.$config.date_locale, options)
    },
    formatLongDate (date) {
      Moment.locale(Vue.$config.date_locale)
      return Moment(date).format(Vue.$config.long_date_format)
    },
    formatDate (date) {
      if (!date) return null

      const formattedDate = new Date(date)
      Moment.locale(Vue.$config.date_locale)
      return Moment(date).format(Vue.$config.date_format) + ' ' + formattedDate.toLocaleTimeString(Vue.$config.date_locale)
    },
    formatFlatDate (date) {
      Moment.locale(Vue.$config.date_locale)
      return Moment(date, 'YYYYMMDD').format(Vue.$config.long_date_format)
    },
    formatAmount (amount) {
      if (isNaN(amount)) {
        return amount
      } else {
        const decimalSep = '.'
        let val = (amount / 1).toFixed(2)
        val = val.replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, decimalSep)
      }
    },
    unformatAmount (currency) {
      var currencyRe = /\D*(\d+|\d.*?\d)(?:\D+(\d{2}))?\D*$/
      var parts = currencyRe.exec(currency)
      return parseFloat(parts[1].replace(/\D/, '') + '.' + (parts[2] ? parts[2] : '00'))
    },
    formatErrorResponse (error, limitError) {
      const apiErrorLink = Vue.$config.help_root + Vue.$apiConfig.apiCodes
      let errorMessage = ''
      let errorLink = ''
      const multipleErrors = []
      if (error.status === 422) {
        const isDuplicate = []
        for (let i = 0; i < error.data.payload.length; i++) {
          const errorPayload = error.data.payload[i]
          const messageItem = {}
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          if (errorPayload.code === 'SYSTEM_USER_NEW_PASSWORD') {
            var message = errorPayload.message.split('-')
            messageItem.msg = i18n.t('apiStatusCodes.' + message[0])
            multipleErrors.push(messageItem)
          } else {
            if (typeof isDuplicate[errorPayload.code] === 'undefined') {
              messageItem.msg = i18n.t('apiStatusCodes.' + errorPayload.code)
              messageItem.index = i
              messageItem.link = apiErrorLink + errorPayload.code
              multipleErrors.push(messageItem)
              isDuplicate[errorPayload.code] = true
            }
          }
        }
      } else if (error.status === 429) {
        if (limitError && limitError.length > 0) {
          errorMessage = i18n.t(limitError)
          errorLink = apiErrorLink + error.status
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          errorLink = apiErrorLink + error.status
        }
      } else {
        if (error.data && error.data.status && error.data.status.code) {
          errorMessage = i18n.t('apiStatusCodes.' + error.data.status.code)
          errorLink = apiErrorLink + error.data.status.code
          if (error.data.additionalInformation && error.data.additionalInformation.length > 0) {
            errorMessage += ' : ' + error.data.additionalInformation
            errorLink = apiErrorLink + error.data.status.code
          }
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          errorLink = apiErrorLink + error.status
        }
      }
      EventBus.$emit('alert', {
        variant: 'error',
        message: errorMessage,
        link: errorLink,
        errors: multipleErrors
      })
    },
    getErrorResponse (error, limitError) {
      const apiErrorLink = Vue.$config.help_root + Vue.$apiConfig.apiCodes
      let errorMessage = ''
      const multipleErrors = []
      if (error.status === 422) {
        const isDuplicate = []
        for (let i = 0; i < error.data.payload.length; i++) {
          const errorPayload = error.data.payload[i]
          const messageItem = {}
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          if (errorPayload.code === 'SYSTEM_USER_NEW_PASSWORD') {
            var message = errorPayload.message.split('-')
            messageItem.msg = i18n.t('apiStatusCodes.' + message[0])
            multipleErrors.push(messageItem)
          } else {
            if (typeof isDuplicate[errorPayload.code] === 'undefined') {
              messageItem.msg = i18n.t('apiStatusCodes.' + errorPayload.code)
              messageItem.index = i
              messageItem.link = apiErrorLink + errorPayload.code
              multipleErrors.push(messageItem)
              isDuplicate[errorPayload.code] = true
            }
          }
        }
      } else if (error.status === 429) {
        if (limitError && limitError.length > 0) {
          errorMessage = i18n.t(limitError)
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
        }
      } else {
        if (error.data && error.data.status && error.data.status.code) {
          errorMessage = i18n.t('apiStatusCodes.' + error.data.status.code)
          if (error.data.additionalInformation && error.data.additionalInformation.length > 0) {
            errorMessage += ' : ' + error.data.additionalInformation
          }
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
        }
      }
      return errorMessage
    },
    getUserSubtype (identificationNumber) {
      const prefix = identificationNumber.substring(0, 3)
      if (typeof this.generatedIdentificationNumbers[prefix] === 'undefined' || this.generatedIdentificationNumbers[prefix] === null) {
        return ''
      }
      return this.generatedIdentificationNumbers[prefix]
    },
    getBankName (bankCode) {
      if (bankCode === '840') {
        return bankCode + ' - ' + 'Банка Управа за Трезор'
      }
      if (bankCode === '360') {
        return bankCode + ' - ' + 'mts banka akcionarsko drustvo, Beograd'
      }
      for (var i = 0; i < Vue.$config.banks.length; i++) {
        if (bankCode === Vue.$config.banks[i].bankId) {
          return bankCode + ' - ' + Vue.$config.banks[i].bankName
        }
      }
      return null
    },
    formatUserStatus (user, userStatus) {
      if (user !== null) {
        if (user.status === userStatus.ACTIVE) {
          const message = i18n.t('subsidyUser.subsidyActive')
          return `${message}<br>Поднета пријава се односи на лица:<br>${user.userBeneficiaries?.join(', ')}`
        } else if (user.status === userStatus.PENDING) {
          if (user.processed === true) {
            return user.errorCode === '4' ? i18n.t('subsidyUser.subsidyFailedBeneficiary') : i18n.t('subsidyUser.subsidyFailed')
          }
          return '<strong>' + i18n.t('subsidyUser.subsidyPending') + '</strong>'
        } else if (user.status === userStatus.WAITING_ACCOUNT) {
          return `${i18n.t('subsidyUser.subsidyWaitingAccount')}<br>Поднета пријава се односи на лица:<br>${user.userBeneficiaries?.join(', ')}`
        } else if (user.status === userStatus.PROCESSED) {
          return `${i18n.t('subsidyUser.subsidyProcessed')}<br>Поднета пријава се односи на лица:<br>${user.userBeneficiaries?.join(', ')}`
        } else if (user.status === userStatus.BLOCKED || user.status === userStatus.TEMP_BLOCKED) {
          return `${i18n.t('subsidyUser.subsidyBlocked')}<br>Поднета пријава се односи на лица:<br>${user.userBeneficiaries?.join(', ')}`
        } else if (user.status === userStatus.COMPLETED) {
          let message = i18n.t('subsidyUser.subsidyCompleted')
          if (user !== null && user.paymentDate !== null) {
            message += ', <strong>' + this.formatDate(user.paymentDate) + '</strong>.'
            message += '<br/>Банка : <strong>' + this.getBankName(user.bank) + '</strong>'
          }
          return `${message}<br>Поднета пријава се односи на лица:<br>${user.userBeneficiaries?.join(', ')}`
        } else if (user.status === userStatus.REJECTED) {
          let message = i18n.t('subsidyUser.subsidyRejectedOperator')
          if (user !== null && user.rejectionDate !== null) {
            message += ', <strong>' + this.formatDate(user.rejectionDate) + '</strong>'
          }
          if (user.rejectionComments !== null) {
            message += '<br><br>' + '<strong>' + user.rejectionComments + '</strong>'
          }
          return message
        } else if (user.status === userStatus.ERROR) {
          let message = i18n.t('subsidyUser.subsidyError')
          if (user !== null && user.paymentDate !== null) {
            message += ' ' + this.formatDate(user.paymentDate)
          }
          if (user.paymentMessage !== null) {
            message += ', ' + i18n.t('subsidyUser.subsidyRejectedReason') + ' : ' + user.paymentMessage
          }
          return message
        }
      }
      return i18n.t('subsidyUser.subsidyActive')
    },
    formatOperatorUserStatus (user, userStatus) {
      if (user !== null) {
        if (user.status === userStatus.ACTIVE) {
          if (user.accountChangeDate) {
            return i18n.t('subsidyUser.subsidyAwaitingPaymentOperator')
          }
          let message = i18n.t('subsidyUser.subsidyActiveOperator')
          if (user !== null && user.activationDate !== null) {
            message += '<br/>' + i18n.t('subsidyUser.activationDate') + ': <strong>' + this.formatDate(this.user.createdDate) + '</strong>'
            if (typeof user.acceptanceDate !== 'undefined' && user.acceptanceDate) {
              message += '<br/>' + i18n.t('subsidyUser.acceptanceDate') + ': <strong>' + this.formatDate(this.user.acceptanceDate) + '</strong>'
              if (user.acceptanceComments !== null) {
                message += ', коментар: ' + '<strong>' + this.user.acceptanceComments + '</strong>'
              }
            }
          }
          return message
        } else if (user.status === userStatus.PENDING) {
          if (user.processed === true) {
            if (user.errorCode) {
              return i18n.t('subsidyUser.subsidyFailedOperator') + ' <strong>' + i18n.t('subsidyUser.rejectionReason.' + user.errorCode) + '</strong>'
            } else {
              return i18n.t('subsidyUser.subsidyFailedOperator')
            }
          }
          return i18n.t('subsidyUser.subsidyPendingOperator')
        } else if (user.status === userStatus.WAITING_ACCOUNT) {
          return i18n.t('subsidyUser.subsidyWaitingAccountOperator')
        } else if (user.status === userStatus.PROCESSED) {
          if (user.paymentMessage) {
            return i18n.t('subsidyUser.subsidyProcessedFailedOperator') + ': <strong>' + user.paymentMessage + '</strong>'
          }
          return i18n.t('subsidyUser.subsidyProcessedOperator')
        } else if (user.status === userStatus.BLOCKED || user.status === userStatus.TEMP_BLOCKED) {
          return i18n.t('subsidyUser.subsidyBlocked')
        } else if (user.status === userStatus.COMPLETED) {
          let message = i18n.t('subsidyUser.subsidyCompletedOperator')
          if (user !== null && user.paymentDate !== null) {
            message += ', <strong>' + this.formatDate(user.paymentDate) + '</strong>' + ', Банка : <strong>' + this.getBankName(user.bank) + '</strong>'
          }
          return message
        } else if (user.status === userStatus.REJECTED) {
          let message = i18n.t('subsidyUser.subsidyRejectedOperator')
          if (user !== null && user.rejectionDate !== null) {
            message += ' ' + this.formatDate(user.rejectionDate)
          }
          if (user.rejectionComments !== null) {
            message += ', ' + i18n.t('subsidyUser.subsidyRejectedReason') + ' : ' + '<strong>' + user.rejectionComments + '</strong>'
          }
          return message
        } else if (user.status === userStatus.ERROR) {
          let message = i18n.t('subsidyUser.subsidyErrorOperator')
          if (user !== null && user.paymentDate !== null) {
            message += ' ' + this.formatDate(user.paymentDate)
          }
          if (user.paymentMessage !== null) {
            message += ', ' + i18n.t('subsidyUser.subsidyRejectedReason') + ' : ' + user.paymentMessage
          }
          return message
        }
      }
      return i18n.t('subsidyUser.subsidyActive')
    },
    toBoldLatin (word) {
      var answer = ''
      var a = {}

      a['А'] = 'a'; a['а'] = 'a'
      a['Б'] = 'b'; a['б'] = 'b'
      a['В'] = 'v'; a['в'] = 'v'
      a['Г'] = 'g'; a['г'] = 'g'
      a['Д'] = 'd'; a['д'] = 'd'
      a['Ђ'] = 'dj'; a['ђ'] = 'dj'
      a['Е'] = 'e'; a['е'] = 'e'
      a['Ж'] = 'z'; a['ж'] = 'z'
      a['З'] = 'z'; a['з'] = 'z'
      a['И'] = 'i'; a['и'] = 'i'
      a['Ј'] = 'j'; a['ј'] = 'j'
      a['К'] = 'k'; a['к'] = 'k'
      a['Л'] = 'l'; a['л'] = 'l'
      a['Љ'] = 'lj'; a['љ'] = 'lj'
      a['М'] = 'm'; a['м'] = 'm'
      a['Н'] = 'n'; a['н'] = 'n'
      a['Њ'] = 'nj'; a['њ'] = 'nj'
      a['О'] = 'o'; a['о'] = 'o'
      a['П'] = 'p'; a['п'] = 'p'
      a['Р'] = 'r'; a['р'] = 'r'
      a['С'] = 's'; a['с'] = 's'
      a['Т'] = 't'; a['т'] = 't'
      a['Ћ'] = 'c'; a['ћ'] = 'c'
      a['У'] = 'u'; a['у'] = 'u'
      a['Ф'] = 'f'; a['ф'] = 'f'
      a['Х'] = 'h'; a['х'] = 'h'
      a['Ц'] = 'c'; a['ц'] = 'c'
      a['Ч'] = 'c'; a['ч'] = 'c'
      a['Џ'] = 'dz'; a['џ'] = 'dz'
      a['Ш'] = 's'; a['ш'] = 's'
      a['Č'] = 'c'; a['č'] = 'c'
      a['Ć'] = 'c'; a['ć'] = 'c'
      a['Š'] = 's'; a['š'] = 's'
      a['Đ'] = 'dj'; a['đ'] = 'dj'
      a['Ž'] = 'z'; a['ž'] = 'z'

      for (const i in word) {
        if (Object.prototype.hasOwnProperty.call(word, i)) {
          if (a[word[i]] === undefined) {
            var letters = /^[0-9a-zA-Z ]+$/
            if (word[i].match(letters)) {
              answer += word[i]
            }
          } else {
            answer += a[word[i]]
          }
        }
      }
      return answer
    },
    browserIE11 () {
      return false || !!document.documentMode
    },
    browserFirefox () {
      return typeof InstallTrigger !== 'undefined'
    },
    helpLink (linkRoute) {
      return (Vue.$config.help_root + '/' + linkRoute).replace(/([^:]\/)\/+/g, '$1')
    }
  }
})
